<template>
  <v-row align="center" justify="center" no-gutters v-if="loading === true">
    <v-progress-circular indeterminate></v-progress-circular>
  </v-row>
  <v-row align="stretch" v-else-if="data.length > 0">
    <v-col cols="12" sm="4" lg="3" v-for="item in data" :key="item.id">
      <v-sheet
        width="100%"
        height="100%"
        rounded
        color="#FFCC80"
        class="no-print"
      >
        <div class="pa-2">
          <v-row dense no-gutters>
            <span class="overline font-weight-medium">{{
              item.name
            }}</span></v-row
          >
          <v-row class="mt-2" align="end" justify="start" dense no-gutters>
            <span
              class="overline font-weight-medium"
              style="font-size: 1rem !important;"
              >{{ item.quantity | round2 }}</span
            >
            <span class="overline ml-1">{{ item.unit }}</span>
          </v-row>
          <v-row
            align="center"
            justify="space-between"
            no-gutters
            dense
            class="mt-2"
          >
            <v-btn x-small color="#FFE0B2" @click="ignore(item)">
              Ignorer
            </v-btn>
            <Prompt
              activator-icon="fa-check"
              activator-text="Confirmer"
              activator-icon-size="x-small"
              activator-size="x-small"
              color="#FFA726"
              type="number"
              input-text="Quantité produite"
              submitText="Confimer la perte"
              :initial-value="item.quantity"
              @submit="v => comfirm(item, v)"
            ></Prompt>
          </v-row>
        </div>
      </v-sheet>

      <!-- <v-row
        dense
        align="center"
        justify="space-between"
        no-gutters
        class="only-print"
      >
        <span class="overline font-weight-medium">{{ item.name }}</span>
        <div>
          <span
            class="overline font-weight-medium"
            style="font-size: 1rem !important;"
            >{{ item.quantity | round2 }}</span
          >
          <span class="overline ml-1">{{ item.unit }}</span>
        </div>
      </v-row> -->
    </v-col>
  </v-row>
  <v-row align="center" no-gutters v-else>
    <span class="caption">Aucune expiration à vérifier</span>
  </v-row>
</template>

<script>
import { api } from "@/api";
import moment from "moment";
import { round10 } from "round10";
import { mapGetters } from "vuex";
export default {
  name: "PreparationSlipViewerExpirationGrid",
  props: {
    date: {
      required: true
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getExpirations", "getProducts", "getStoreId"])
  },
  data() {
    return {
      loading: false,
      data: [],
      headers: [
        { value: "name" },
        { value: "quantity" },
        { value: "expiration_date" }
      ]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.data = this.getExpirations
          .filter(x =>
            moment(x.expiration_date).isSame(moment(this.date), "day")
          )
          .map(x => {
            const p = this.getProducts.find(p => p.id === x.product);
            if (p !== undefined) {
              return {
                id: x.transaction_id,
                date: x.production_date,
                expiration_date: x.expiration_date,
                name: p.nom,
                quantity: Number(x.quantity),
                threshold: Math.ceil(
                  moment(x.expiration_date).diff(moment(), "hours") / 24
                ),
                unit: p.data.unite_mesure_inventory,
                type: 0,
                productId: x.product,
                correction_value: Math.abs(
                  round10(
                    Number(x.quantity) * Number(p.data.prix_inventory),
                    -2
                  )
                ),
                transaction: x.transaction
              };
            }
          })
          .filter(e => e !== undefined);
      } finally {
        this.loading = false;
      }
    },
    async comfirm(item, value) {
      if (value !== null) {
        const d = {
          fk_product: item.productId,
          store: this.getStoreId,
          date: moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
          comments: null,
          waste_cause: null,
          quantity: -1 * Math.abs(value),
          transaction_type: 4
        };
        api.postInventoryTransaction(d);
        this.$store.dispatch("loadInventoryRecords", {
          store: this.getStoreId,
          latest: true
        });
        this.data = this.data.filter(x => x.id !== item.id);
      }
    },
    async ignore(item) {
      const d = {
        ...item.transaction,
        id: item.id,
        is_consumed: true
      };
      api.patchInventoryTransaction(d);
      this.$store.dispatch("loadInventoryRecords", {
        store: this.getStoreId,
        latest: true
      });
      this.data = this.data.filter(x => x.id !== item.id);
    }
  },
  watch: {
    getExpirations: {
      deep: true,
      handler: "getData"
    }
  }
};
</script>

<style></style>
